import constants from 'src/constants';
import { utils as macheteReduxUtils } from 'src/machete-redux';

const { APP_TYPE_PARAM } = constants.app;

/**
 * The native team has created the query param
 * 'app=native' so that we can distinguish between the
 * native apps and the React native apps. When this param
 * is present the app is in the current native apps and not
 * the React Native Apps.
 * @param {object} queryStringMap
 * @returns {boolean}
 */
const isFromNativeApp = (queryStringMap) => {
  const appType = queryStringMap[APP_TYPE_PARAM];

  if (appType === 'native') return true;

  return false;
};

const extractWindowNodeData = (uuid) => {
  const node = macheteReduxUtils.getNode(uuid);
  const { originalModelElements = [] } = node;
  if (originalModelElements[0]) {
    return originalModelElements[0].parametricOptions.attributes;
  }
};

export default {
  extractWindowNodeData,
  isFromNativeApp,
};
